
const downloadUrl = (url, fileName) => {
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', fileName)

  link.click()

}

export default downloadUrl
